import { formatCurrency, WHOLE_DOLLARS } from '@/lib/formatters'

interface Props {
  /** What the priced lines add up to. */
  premium: number
  lines: number
  unpricedLines: number
}

/** A premium that admits what it lacks: unknown when no line was priced, flagged when some weren't. */
export function PremiumFigure({ premium, lines, unpricedLines }: Props) {
  if (unpricedLines === lines) return <span className="text-amber-700 dark:text-amber-400">no premium</span>

  return (
    <>
      {formatCurrency(premium, WHOLE_DOLLARS)}
      {unpricedLines > 0 && (
        <span className="ml-1 text-amber-700 dark:text-amber-400">+ {unpricedLines} unpriced</span>
      )}
    </>
  )
}
